import { RegionConfig, RemoteConfig } from '@ca/common/types'
import { getStaticRegion } from 'config/AppConfig'
import { useMemo } from 'react'
import stateStorage from 'storage/stateStorage'
import { getAppRegion, useAppRegion } from 'storage/useRemoteConfigParams'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type RemoteConfigStoreState = {
  version: number
  config: RemoteConfig | null
  updatedAt: number
}

type RemoteConfigStoreActions = {
  update: (config: Omit<RemoteConfigStoreState, 'updatedAt'>) => void
}

export const PERSIST_KEY_REMOTE_CONFIG = 'remoteConfigStore'

export const useRemoteConfigStore = create<
  RemoteConfigStoreState & RemoteConfigStoreActions,
  [['zustand/persist', { store: RemoteConfigStoreState | null }]]
>(
  persist(
    (set) => ({
      version: 0,
      config: null,
      updatedAt: 0,
      update: (val) =>
        set({
          ...val,
          config: val.config
            ? {
                ...val.config,
                region: {
                  ...val.config.region,
                  vat:
                    val.config.region.vat ??
                    getStaticRegion(val.config?.region.countryCode)?.vat,
                } satisfies RegionConfig,
              }
            : null,
          updatedAt: Date.now(),
        }),
    }),
    {
      name: PERSIST_KEY_REMOTE_CONFIG,
      storage: createJSONStorage(() => stateStorage),
    }
  )
)

export const useRemoteConfig = () => {
  const value = useRemoteConfigStore((state) => state.config)
  // const appRegion = useAppRegion()

  // return useMemo(() => {
  //   if (!value) {
  //     return null
  //   }
  //   console.log(
  //     'useRemoteConfig memo running',
  //     appRegion.code,
  //     value.region.countryCode
  //   )
  //   return {
  //     ...value,
  //     region: {
  //       ...value?.region,
  //       vat: value?.region?.vat ?? appRegion?.vat,
  //     },
  //   } satisfies RemoteConfig
  // }, [value, appRegion?.code])
  return value
}

export const getRemoteConfig = () => {
  return useRemoteConfigStore.getState().config
}

export function getRemoteConfigFromLocalStorage() {
  try {
    const raw = stateStorage.getItem(PERSIST_KEY_REMOTE_CONFIG)
    if (!raw || typeof raw !== 'string') {
      return undefined
    }
    const parsed = JSON.parse(raw)
    return parsed
  } catch {
    return undefined
  }
}
